var $393254ebcb66c9f5$exports = {};
$393254ebcb66c9f5$exports = {
  "Empty": "\u041F\u0443\u0441\u0442\u043E"
};
export { $393254ebcb66c9f5$exports as default };